export default "__VITE_ASSET__BVFyUYG___"